import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';

/** Detalhe da transação (aba "Transação" + cabeçalho da página). */
export function useTransaction(transactionId: string) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transaction', transactionId],
    queryFn: () => repository.getTransaction(transactionId),
    staleTime: 1000 * 60 * 5,
    enabled: !!transactionId,
    retry: false,
  });
}
